import { render, staticRenderFns } from "./EthnicityPanel.vue?vue&type=template&id=fc9e435a&scoped=true"
import script from "./EthnicityPanel.vue?vue&type=script&lang=js"
export * from "./EthnicityPanel.vue?vue&type=script&lang=js"
import style0 from "./EthnicityPanel.vue?vue&type=style&index=0&id=fc9e435a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9e435a",
  null
  
)

export default component.exports